// Libs
import * as MobX from "mobx";
import { ModelBase } from "@shoothill/core";
import { IsNotEmpty, IsCurrency, IsPositive } from "class-validator";

// Dto
import { OutstandingLoanDTO } from "Globals/Models/DTO/OutstandingLoanDTO";

import { StoresInstance } from "Globals/Stores";

export class OutstandingLoanModel extends ModelBase<OutstandingLoanModel, OutstandingLoanDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public incomeDetailId: string | null = null;

    @IsNotEmpty({ message: "Loan is in the name of is required" })
    @MobX.observable
    public loanIsInNameOf: string | null = null;

    @IsNotEmpty({ message: "Purpose of loan is required" })
    @MobX.observable
    public loanPurposeId: string | null = "0";

    @IsNotEmpty({ message: "Name of lender is required" })
    @MobX.observable
    public lenderId: string | null = "0";

    @MobX.observable
    public otherLender: string = "";

    @IsNotEmpty({ message: "Monthly payment amount is required" })
    @MobX.observable
    public monthlyPayment: number | null = null;

    @IsNotEmpty({ message: "Total amount outstanding is required" })
    @MobX.observable
    public totalAmountOutstanding: number | null = null;

    @IsNotEmpty({ message: "Final payment date is required" })
    @MobX.observable
    public dateOfFinalPayment: Date | null = new Date();

    @MobX.observable
    public sameForApplicantTwo: boolean = false;

    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.computed
    public get getIsLenderOther(): boolean {
        if (StoresInstance.Domain.LenderTypeStore.getLendersName(this.lenderId).toLocaleLowerCase() === "other") {
            return true;
        }

        return false;
    }

    @MobX.action
    public fromDto = (model: OutstandingLoanDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.incomeDetailId = model.incomeDetailId;
            this.loanIsInNameOf = model.loanIsInNameOf;
            this.loanPurposeId = model.loanPurposeId;
            this.lenderId = model.lenderId;
            this.otherLender = model.otherLender;
            this.monthlyPayment = model.monthlyPayment;
            this.totalAmountOutstanding = model.totalAmountOutstanding;
            this.dateOfFinalPayment = model.dateOfFinalPayment;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
            this.sameForApplicantTwo = model.sameForApplicantTwo;
        }
    };

    @MobX.action
    public toDto = (): OutstandingLoanDTO => {
        let model: OutstandingLoanDTO = {
            id: this.id,
            incomeDetailId: this.incomeDetailId,
            loanIsInNameOf: this.loanIsInNameOf,
            loanPurposeId: this.loanPurposeId,
            lenderId: this.lenderId,
            otherLender: this.otherLender,
            monthlyPayment: this.monthlyPayment,
            totalAmountOutstanding: this.totalAmountOutstanding,
            dateOfFinalPayment: this.dateOfFinalPayment,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
            sameForApplicantTwo: this.sameForApplicantTwo,
        };
        return model;
    };
    @MobX.action
    public resetModel = (): void => {
        this.id = null;
        this.incomeDetailId = null;
        this.loanIsInNameOf = "";
        this.loanPurposeId = "0";
        this.lenderId = "0";
        this.monthlyPayment = null;
        this.totalAmountOutstanding = null;
        this.dateOfFinalPayment = new Date();
        this.createdDate = null;
        this.isDeleted = false;
        this.sameForApplicantTwo = false;
    };
}
